/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import {
	closeSocialContentModal,
	openSocialContentModal,
	setProductSocialContentState
} from '../actions';

import { ProductSocialContentState } from '../../model';

/** @format */

export const initialProductSocialContentState: ProductSocialContentState = {
	resultsCount: 0,
	items: [],
	socialModal: false
};

export const productSocialContentReducers = createReducer(
	initialProductSocialContentState,
	on(setProductSocialContentState, (state, { resultsCount, items }) => ({
		...state,
		resultsCount,
		items
	})),
	on(openSocialContentModal, (state) => ({
		...state,
		socialModal: true
	})),
	on(closeSocialContentModal, (state) => ({
		...state,
		socialModal: false
	}))
);

export const productSocialContentReducer = (state: ProductSocialContentState, action: Action) =>
	productSocialContentReducers(state, action);
